"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");
import logger from "@/utils/logger";

export async function svc_getOutlets(brandID) {
	let payload = {};
	if (brandID) {
		if (typeof brandID === "object") {
			if (brandID["brand"]) {
				payload["brand"] = brandID;
			}
		} else {
			payload["brand"] = brandID;
		}
	}

	return request(`${config.apiUrl}outlets`, {
		method: "GET",
		params: payload,
	});
}

export async function svc_getOutletsFull(brandID) {
	let payload = { brand: brandID.id };

	return request(`${config.apiUrl}outlets/all/outlets`, {
		method: "GET",
		query: payload,
	});
}